class CDNPath {

    constructor() {

        return function(src) {
            if(/^http/.test(src)) {
                return src;
            }
            else if(/^\/\//.test(src)) {
                return src;
            }
            else {
                return "https://cdn.ctnsnet.com/ase/fetch/uas/" + src;
            }
        };
    }
}

angular.module('cpm')
.filter('cdnPath', [ () => {
    'use strict';
    return new CDNPath();
}]);

